import { render, staticRenderFns } from "./CommercialEnterprise.vue?vue&type=template&id=16735755&scoped=true&"
import script from "./CommercialEnterprise.vue?vue&type=script&lang=js&"
export * from "./CommercialEnterprise.vue?vue&type=script&lang=js&"
import style0 from "./CommercialEnterprise.vue?vue&type=style&index=0&id=16735755&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16735755",
  null
  
)

export default component.exports